import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const AccordianPlusIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.75586 11L1.6543 10.9951C1.14986 10.9441 0.755859 10.5179 0.755859 10C0.75586 9.4821 1.14986 9.05592 1.6543 9.00488L1.75586 9L18 9C18.5523 9 19 9.44772 19 10C19 10.5523 18.5523 11 18 11L1.75586 11Z"
      fill="#EEF7FF"
    />
    <path
      d="M8.87891 1.87695L8.88379 1.77539C8.93483 1.27095 9.36101 0.876953 9.87891 0.876953C10.3968 0.876953 10.823 1.27095 10.874 1.77539L10.8789 1.87695L10.8789 18.1211C10.8789 18.6734 10.4312 19.1211 9.87891 19.1211C9.32662 19.1211 8.87891 18.6734 8.87891 18.1211L8.87891 1.87695Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default AccordianPlusIconDark;
